window.moneyFormat = document.currentScript.getAttribute("money-format") || "${{amount}}";
window.cartCurrencyIsoCode = document.currentScript.getAttribute("cart-currency-iso-code") || "";

// ✅ HackWrapper.js (Global Vars + Private Copies)
(function (global) {
    // ----------------------
    // Global Vars (Define Once Globally)
    // ----------------------
    if (typeof global.fetchController === "undefined") {
        global.fetchController = null;
    }
    if (typeof global.baseUrl === "undefined") {
        global.baseUrl = "";
    }
    if (typeof global.cartCurrencyIsoCode === "undefined") {
        global.cartCurrencyIsoCode = Shopify?.currency?.active || "USD";
    }
    if (typeof global.moneyFormat === "undefined") {
        global.moneyFormat = "${{ amount }}";
    }

    // ----------------------
    // Private Copies (Only Accessible in HackWrapper)
    // ----------------------
    const _fetchController = global.fetchController;
    const _baseUrl = global.baseUrl;
    const _cartCurrencyIsoCode = global.cartCurrencyIsoCode;
    const _moneyFormat = global.moneyFormat;

    // ----------------------
    // Core Functions (Use Private Copies)
    // ----------------------
    function setValue(initialValue = null) {
        return initialValue;
    }

    function getType(value) {
        if (Array.isArray(value)) return "array";
        if (value === null) return "null";
        return typeof value;
    }

    function isEmpty(value) {
        if (value == undefined) return true;
        if (value == null) return true;
        if (typeof value === "string" || Array.isArray(value)) {
            return value.length === 0;
        }
        if (typeof value === "object") {
            return Object.keys(value).length === 0;
        }
        return false;
    }

    function mapValue(value, fn) {
        if (Array.isArray(value)) {
            return value.map(fn);
        }
        return fn(value);
    }

    function filterValue(value, fn) {
        if (Array.isArray(value)) {
            return value.filter(fn);
        }
        return value;
    }

    function reduceValue(value, fn, initial) {
        if (Array.isArray(value)) {
            return value.reduce(fn, initial);
        }
        return value;
    }

    function cloneValue(value) {
        if (Array.isArray(value)) return [...value];
        if (typeof value === "object" && value !== null) {
            return JSON.parse(JSON.stringify(value));
        }
        return value;
    }

    function logValue(value, label = "HackWrapper") {
        console.log(`${label}:`, value);
        return value;
    }

    // ----------------------
    // Static Utilities (Private Copies)
    // ----------------------
    function setBaseUrl(url) {
        global.baseUrl = url; // Update global var
    }

    async function fetchData(baseUrl = _baseUrl, params, _method = "POST") {
        if (_fetchController) _fetchController.abort();
        global.fetchController = new AbortController();
        
        try {
            const response = await fetch(baseUrl, {
                method: _method,
                body: params,
                signal: global.fetchController.signal,
            });

            if (!response.ok) {
                throw new Error(`Request failed: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            return { error: error.message };
        }
    }

    function formatMoney(cents, format = _moneyFormat) {
        if (typeof cents === "string") cents = cents.replace(".", "");
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || _moneyFormat;
        const formatWithDelimiters = (
            number,
            precision = 2,
            thousands = ",",
            decimal = "."
        ) => {
            if (isNaN(number) || number == null) return "0";
            number = (number / 100).toFixed(precision);
            const [dollars, cents] = number.split(".");
            const formattedDollars = dollars.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
            return formattedDollars + (cents ? `${decimal}${cents}` : "");
        };

        const placeholder = formatString.match(placeholderRegex)?.[1];
        let value = "";

        switch (placeholder) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            default:
                value = cents;
        }

        return formatString.replace(placeholderRegex, value);
    }

    function convertToShopCurrency(dollarPrice) {
        let rate = 1;

        if (typeof Currency !== "undefined" && Currency.rates?.[_cartCurrencyIsoCode]) {
            if (_cartCurrencyIsoCode !== "USD") {
                rate = Currency.rates[_cartCurrencyIsoCode];
            }
        }

        return parseFloat((dollarPrice / rate).toFixed(2));
    }

    function convertToDollar(shopPrice) {
        let rate = 1;

        if (typeof Currency !== "undefined" && Currency.rates?.[_cartCurrencyIsoCode]) {
            if (_cartCurrencyIsoCode !== "USD") {
                rate = Currency.rates[_cartCurrencyIsoCode];
            }
        }

        return parseFloat((shopPrice * rate).toFixed(2));
    }

    function handleize(str) {
        return str
            .toLowerCase()
            .replace(/["'\\()[\]]/g, "")
            .replace(/\W+/g, "-")
            .replace(/^[-]+|[-]+$/g, "");
    }

    function getElement(selector) {
        return document.querySelector(selector) ?? null;
    }

    function getElements(selector) {
        return Array.from(document.querySelectorAll(selector)) ?? [];
    }

    function showElements(selector) {
        getElements(selector).forEach(el => (el.style.display = "block"));
    }

    function hideElements(selector) {
        getElements(selector).forEach(el => (el.style.display = "none"));
    }

    async function addToCart(_button, variantId, quantity = 1, properties = {}) {
        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", quantity);

        Object.entries(properties).forEach(([key, value]) => {
            formData.append(`properties[${key}]`, value);
        });

        try {
            const response = await fetch("/cart/add.js", {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                const err = await response.json();
                throw { status: response.status, message: err.description };
            }

            await response.json();
            location.href = "/cart";

            resetAddToCartButton(_button);
        } catch (err) {
            window.addToCartRetryCount = (window.addToCartRetryCount || 0) + 1;

            if (window.addToCartRetryCount > 25) {
                resetAddToCartButton(_button);
                return;
            } else {
                this.addToCart(_button, variantId, quantity, properties);
            }
        }

        resetAddToCartButton(button);
    }

    function resetAddToCartButton(button) {
        button.disabled = false;
        button.classList.remove("disabled");
        button.textContent = "Add to cart";
    }

    function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split("&"), sParameterName, i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split("=");
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    }
    
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
    }
    
    function setCookie(name, value, expirationInHours) {
        const date = new Date;
        date.setTime(date.getTime() + expirationInHours * 60 * 60 * 1e3);
        const expires = "expires=" + date.toUTCString();
        document.cookie = `${name}=${value}; ${expires}; path=/`
    }

    function getCookie(name) {
        const cookiesArray = decodeURIComponent(document.cookie).split(";");
        for (let cookie of cookiesArray)
            if (cookie = cookie.trim(), cookie.startsWith(name + "=")) return cookie.substring(name.length + 1);
        return null
    }

    function deleteCookie(name) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
    }

    function validateField(fieldType = "name", fieldName, fieldValue) {
        let regex;
        let errorMessage = "";
        switch (fieldType) {
            case "name":
                regex = /^[a-zA-Z\s]+$/;
                errorMessage = `${fieldName} is required.`;
                break;
            case "email":
                // Check for different email validation scenarios
                if (fieldValue === "") {
                    errorMessage = "Email is required.";
                } else if (!fieldValue.includes("@")) {
                    errorMessage = 'Email must contain an "@" symbol.';
                } else if (fieldValue.startsWith("@") || fieldValue.endsWith("@")) {
                    errorMessage = 'Email cannot start or end with "@" symbol.';
                } else if (!fieldValue.includes(".")) {
                    errorMessage = 'Email must contain a domain (e.g., ".com").';
                } else if (fieldValue.split("@")[1].startsWith(".")) {
                    errorMessage = "Email domain cannot start with a period.";
                } else {
                    regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!regex.test(fieldValue)) {
                        errorMessage = "Please enter a valid email address.";
                    }
                }
                break;
            case "phone":
                // Check for different phone number validation scenarios
                if (fieldValue === "") {
                    errorMessage = "Phone number is required.";
                } else if (!/^\d+$/.test(fieldValue)) {
                    errorMessage = "Phone number must contain only digits.";
                } else if (fieldValue.length < 10) {
                    errorMessage =
                        "Phone number is too short. It should be 10 digits long.";
                } else if (fieldValue.length > 10) {
                    errorMessage =
                        "Phone number is too long. It should be 10 digits long.";
                } else {
                    regex = /^\d{10}$/;
                    if (!regex.test(fieldValue)) {
                        errorMessage = "Please enter a valid 10-digit phone number.";
                    }
                }
                break;
            default:
                return ""; // If the field doesn't need validation, return true
        }

        if (errorMessage) {
            return errorMessage;
        } else {
            return "";
        }
    }

    /**
     * Extracts values around a dynamic delimiter, trims spaces,
     * and supports multiple occurrences.
     *
     * @param {string} input - The input string
     * @param {string} delimiter - The separator symbol (e.g. "|", "-", ":", etc.)
     * @param {"before" | "after" | "both" | "all"} mode - What to return
     * @returns {string | { before: string, after: string } | string[]}
     */
    function extractByDelimiter(input, delimiter = "|", mode = "before") {
        if (typeof input !== "string" || typeof delimiter !== "string" || !delimiter) {
            return mode === "all" ? [] : "";
        }

        const parts = input.split(delimiter).map(p => p.trim());
        const before = parts[0] || "";
        const after = parts.length > 1 ? parts.slice(1).join(` ${delimiter} `).trim() : "";

        switch (mode) {
            case "before":
                return before;
            case "after":
                return after;
            case "both":
                return { before, after };
            case "all":
                return parts;
            default:
                return before;
        }
    }

    /**
     * Dynamically upserts query parameters into the current URL
     * and returns the full query string (including the leading '?').
     *
     * @param {string|Object} keyOrParams - Either a string key or an object of key-value pairs
     * @param {string|string[]} [value] - The value(s) to set if keyOrParams is a string
     * @returns {string} - The updated query string (e.g. "?foo=bar&baz=2")
     */
    function upsertQueryParams(keyOrParams, value) {
        const urlObj = new URL(window.location.href);
        const params = urlObj.searchParams;

        if (typeof keyOrParams === 'object' && keyOrParams !== null) {
            // Handle multiple key-value pairs
            for (const [key, val] of Object.entries(keyOrParams)) {
                if (Array.isArray(val)) {
                    params.delete(key);
                    val.forEach(v => params.append(key, v));
                } else {
                    params.set(key, val);
                }
            }
        } else if (typeof keyOrParams === 'string') {
            // Handle single key-value pair
            if (Array.isArray(value)) {
                params.delete(keyOrParams);
                value.forEach(v => params.append(keyOrParams, v));
            } else {
                params.set(keyOrParams, value);
            }
        } else {
            throw new Error('Invalid arguments passed to upsertQueryParams');
        }

        // Return the query string with a leading '?'
        const queryString = params.toString();
        return queryString ? `?${queryString}` : '';
    }

    // ----------------------
    // Shopify Currency Loader
    // ----------------------
    (function loadShopifyCurrencyScript() {
        if (typeof window !== "undefined" && typeof document !== "undefined") {
            if (typeof Currency === "undefined") { // ✅ Only load if Currency not already defined
                const existing = document.querySelector('script[src*="currencies.js"]');
                if (!existing) {
                    const script = document.createElement("script");
                    script.src = "https://cdn.shopify.com/s/javascripts/currencies.js";
                    script.async = true;
                    script.onload = () => console.log("✅ Shopify currencies.js loaded");
                    script.onerror = () => console.warn("⚠️ Failed to load currencies.js");
                    document.head.appendChild(script);
                }
            } else {
                console.log("✅ Shopify currencies.js already loaded (Currency exists)");
            }
        }
    })();

    // ----------------------
    // Expose Only HackWrapper
    // ----------------------
    const HackWrapper = {
        setValue,
        getType,
        isEmpty,
        mapValue,
        filterValue,
        reduceValue,
        cloneValue,
        logValue,
        setBaseUrl,
        fetchData,
        formatMoney,
        convertToShopCurrency,
        convertToDollar,
        handleize,
        getElement,
        getElements,
        showElements,
        hideElements,
        addToCart,
        getUrlParameter,
        sleep,
        setCookie,
        getCookie,
        deleteCookie,
        validateField,
        extractByDelimiter,
        upsertQueryParams
    };

    if (typeof module !== "undefined" && module.exports) {
        module.exports = HackWrapper;
    } else {
        global.HackWrapper = HackWrapper;
    }

})(typeof window !== "undefined" ? window : global);